import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {isNotEmpty, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {initialUser, Company} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {CompanyListLoading} from '../components/loading/CompanyListLoading'
import {updateUser, updateUserDetail, updatePassword, createCompany} from '../core/_requests'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {PasswordMeterComponent} from '../../../../../../_metronic/assets/ts/components'
import Select from 'react-select'
import {getAllUsers, getUsers} from '../../../user-management/users-list/core/_requests'
import { User } from '../../../user-management/users-list/core/_models'
import { useCompanies } from '../../../../auth/core/Companies'

type Props = {
  isUserLoading: boolean
  user: Company
}

const UserEditModalForm: FC<Props> = ({user, isUserLoading}) => {
  const {setItemIdForUpdate, setpasswordUpdateCheck, passwordUpdateCheck} = useListView()
  const {refetch} = useQueryResponse()
  let editUserSchema
  const [selectedUsers, setselectedUsers] = useState([]);
  const [selectedIds, setselectedIds] = useState(null);
  const {companies,fetchCompaniesFromAPI} = useCompanies();

  const [options, setoptions] = useState([]);


 
  useEffect(() => {
    console.log(companies);

    const fetchUsers = async () => {
      try {
        const response = await getAllUsers() // Make an API request to get the list of users
        var data = response.map((item:User) => ({
          value: item._id,
          label: item.fullName,
        }));
        setoptions(data);
        const filteredData = data.filter((item: { value: string }) => (user?.users as unknown as string[])?.includes(item.value)); 
        setselectedUsers(filteredData);
      } catch (error) {
        console.error(error)
      }
    }
    fetchUsers()
  }, [])

  useEffect(() => {
   
  }, [options])

  const handleSelectChange = (selected:any) => {
    setselectedUsers(selected);
  };

  if (!isNotEmpty(user._id)) {
    editUserSchema = Yup.object().shape({
      name: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Name is required'),
      slug: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Slug is required'),
    })
  } else {
    editUserSchema = Yup.object().shape({
      name: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
      slug: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Name is required'),
    })
  }

  const [userForEdit] = useState<Company>({
    ...user,
    name: user.name || initialUser.name,
    slug: user.slug || initialUser.slug,
    users : selectedIds || initialUser.users
  })
  const customStyles = {
    control: (provided:any) => ({
      ...provided,
      backgroundColor: 'transparent',
      borderColor: '#4a5568', // Adjust the border color for better visibility
      boxShadow: 'none', // Remove the box shadow
    }),
    option: (provided:any, state:any) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#4a5568' : '#fffff', // Adjust the background color for focused and non-focused options
      color: state.isFocused ? 'white' : 'black', // Adjust the text color for focused and non-focused options
    }),
  };

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setpasswordUpdateCheck(false)
    setItemIdForUpdate(undefined)
  }

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])


  const formik = useFormik({
    initialValues: userForEdit,
    validationSchema: editUserSchema,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)
      const companiesList: any = selectedUsers.map((obj: any) => obj.value);  
      values.users = companiesList;
      try {
       
          if (isNotEmpty(values._id)) {
            await updateUserDetail(values)
          } else {
            await createCompany(values)
            await fetchCompaniesFromAPI();
            window.location.reload();
          }
       
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  return (
    <>
      <form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_user_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_user_header'
          data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}

          {!passwordUpdateCheck && (
            <div>
              {/* begin::Input group */}
              <div className='row'>
                <div className='col'>
                  {/* begin::Label */}
                  <label className='required fw-bold fs-6 mb-2'> Name</label>
                  {/* end::Label */}

                  {/* begin::Input */}
                  <input
                    placeholder='Name'
                    {...formik.getFieldProps('name')}
                    type='text'
                    name='name'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      {'is-invalid': formik.touched.name && formik.errors.name},
                      {
                        'is-valid': formik.touched.name && !formik.errors.name,
                      }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isUserLoading}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.name}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Input */}

                <div className='col'>
                  <label className='required fw-bold fs-6 mb-2'>Slug</label>
                  {/* end::Label */}

                  {/* begin::Input */}
                  <input
                    placeholder='Slug'
                    {...formik.getFieldProps('slug')}
                    type='text'
                    name='slug'
                    className={clsx(
                      'form-control form-control-solid mb-3 mb-lg-0',
                      {'is-invalid': formik.touched.slug && formik.errors.slug},
                      {
                        'is-valid': formik.touched.slug && !formik.errors.slug,
                      }
                    )}
                    autoComplete='off'
                    disabled={formik.isSubmitting || isUserLoading}
                  />
                  {formik.touched.slug && formik.errors.slug && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.slug}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* end::Input group */}

              {/* begin::Input group */}
            </div>
          )}

          {/* end::Input group */}
        </div>
        <div className='mt-2'>
        <Select
        isMulti
        styles={customStyles}
        value={selectedUsers}
        onChange={handleSelectChange}
        options={options}
      />
        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
            disabled={formik.isSubmitting || isUserLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isUserLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>
      {(formik.isSubmitting || isUserLoading) && <CompanyListLoading />}
    </>
  )
}

export {UserEditModalForm}
